// 把所有用户操作的功能，全写在这里
import axios from '@/utils/request'

// 获取商品列表
export function getList (params) {
  return axios({
    method: 'get',
    url: '/api/h5',
    params
  })
}

// 确认收货 
export function Receive (data) {
  return axios({
    method: 'POST',
    url: '/api/order/addOrUpdate',
    data
  })
}
// 获取收款二维码
export function getPay () {
  return axios({
    method: 'get',
    url: '/api/payList'
  })
}

